/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { TaxDocumentAttachmentRequest } from './TaxDocumentAttachmentRequest';

export type TaxDocumentUploadRequest = {
    attachments?: Array<TaxDocumentAttachmentRequest>;
    clientId?: string;
    multi?: boolean;
    ownerNote?: string;
    source?: TaxDocumentUploadRequest.source;
};

export namespace TaxDocumentUploadRequest {

    export enum source {
        MOBILE_SCAN = 'MOBILE_SCAN',
        MOBILE_FILE = 'MOBILE_FILE',
        WEB_FILE = 'WEB_FILE',
        EMAIL = 'EMAIL',
    }


}

